import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {formatScheduleDateTime} from '@Libraries/social-media-wizard-scheduling-library';
import type {WizardMobileScheduledBannerProps} from './wizard-mobile-scheduled-banner.types';
import styles from './wizard-mobile-scheduled-banner.module.scss';

export function WizardMobileScheduledBanner({socialPost, onEdit}: WizardMobileScheduledBannerProps): ReactElement {
  return (
    <ClickableDiv className={styles.scheduledBanner} onClick={onEdit} aria-label={window.i18next.t('pmwjs_edit_scheduled_time')}>
      <Text className={styles.scheduledBannerLabel} size={TextSize.MD} val={window.i18next.t('pmwjs_post_will_be_sent_on')} />
      <Text className={styles.scheduledBannerLabel} bold size={TextSize.MD} val={formatScheduleDateTime(socialPost)} />
      <Icon icon="icon-pencil" size={IconSize.SIZE_ICON_16} />
    </ClickableDiv>
  );
}
